<template>
  <div id="components-modal-demo-position">
    <a-modal
      v-model="modalVisible"
      title="Vertically centered modal dialog"
      centered
      @ok="() => (modalVisible = false)"
    >
      <p>some contents...</p>
      <p>some contents...</p>
      <p>some contents...</p>
    </a-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      modalVisible: false
    }
  },
  methods: {
    showModal() {
      this.modalVisible = true
    }
  }
}
</script>
